import { useState, useEffect, useRef } from 'react';

interface Testimonial {
  text: string;
  name: string;
  company: string;
  location: string;
  flag: string;
  rating: number;
  image: string;
}

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleCount, setVisibleCount] = useState(3);
  const autoRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const testimonials: Testimonial[] = [
    {
      text: 'JB GlobeX has been our most reliable partner for sourcing quality jaggery and spices from India. Their commitment to quality and timely delivery is simply exceptional. We\'ve been extremely satisfied with every shipment.',
      name: 'Michael Anderson',
      company: 'Global Foods Ltd.',
      location: 'United Kingdom',
      flag: '🇬🇧',
      rating: 5,
      image: 'https://public.readdy.ai/ai/img_res/2cde36d6e0ab8eb7d69cfba5d4ab3669.jpg',
    },
    {
      text: 'We have been importing textiles from JB GlobeX for over two years. The quality is always consistent and their customer service is outstanding. They truly understand international buyer needs.',
      name: 'Sarah Martinez',
      company: 'Textile Imports Inc.',
      location: 'United States',
      flag: '🇺🇸',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=professional%20American%20businesswoman%20smiling%20confident%20portrait%20white%20background%20corporate%20headshot%20brown%20hair%20formal%20attire&width=200&height=200&seq=t2&orientation=squarish',
    },
    {
      text: 'Excellent quality products and very competitive pricing. JB GlobeX understands the needs of international buyers and delivers accordingly. Their black pepper and turmeric are among the best we have sourced.',
      name: 'Ahmed Al-Rashid',
      company: 'Middle East Trading Co.',
      location: 'UAE',
      flag: '🇦🇪',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=professional%20Middle%20Eastern%20businessman%20wearing%20formal%20business%20suit%20smiling%20confident%20portrait%20clean%20white%20background%20corporate%20headshot&width=200&height=200&seq=t3&orientation=squarish',
    },
    {
      text: 'JB GlobeX has provided us with premium dried mushrooms that meet our restaurant chain\'s high standards. The Oyster and Milky mushrooms are of exceptional quality, and their packaging is export-grade.',
      name: 'Hiroshi Tanaka',
      company: 'Tanaka Foods Japan',
      location: 'Japan',
      flag: '🇯🇵',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=professional%20Japanese%20businessman%20in%20formal%20suit%20smiling%20portrait%20clean%20white%20background%20corporate%20headshot%20middle%20aged%20confident&width=200&height=200&seq=t4&orientation=squarish',
    },
    {
      text: 'We are delighted with the quality of jaggery blocks and turmeric powder from JB GlobeX. Their hygienic processing and export-ready packaging are impressive. A truly trustworthy export partner from India.',
      name: 'Emma Wilson',
      company: 'Pure Organics Australia',
      location: 'Australia',
      flag: '🇦🇺',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=professional%20Australian%20businesswoman%20smiling%20portrait%20white%20background%20corporate%20headshot%20blonde%20confident%20formal%20attire&width=200&height=200&seq=t5&orientation=squarish',
    },
    {
      text: 'The black pepper we source from JB GlobeX has a strong aroma and consistent quality that our clients love. Their supply chain is reliable and they always meet our delivery timelines. Highly recommended!',
      name: 'Klaus Mueller',
      company: 'Spice House Europe',
      location: 'Germany',
      flag: '🇩🇪',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=professional%20German%20businessman%20middle%20aged%20formal%20suit%20confident%20smile%20portrait%20clean%20white%20background%20corporate%20headshot&width=200&height=200&seq=t6&orientation=squarish',
    },
    {
      text: 'JB GlobeX has been an invaluable partner in sourcing Indian agricultural products for our distribution network. Their textile quality and competitive pricing make them our preferred supplier for the Canadian market.',
      name: 'Priya Nair',
      company: 'Indo-Canada Traders',
      location: 'Canada',
      flag: '🇨🇦',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=professional%20Indian%20Canadian%20businesswoman%20smiling%20confident%20portrait%20white%20background%20corporate%20headshot%20formal%20attire%20elegant&width=200&height=200&seq=t7&orientation=squarish',
    },
    {
      text: 'We import turmeric and black pepper in bulk from JB GlobeX for our spice processing plant. The curcumin content and piperine levels consistently meet our lab standards. A truly professional export company.',
      name: 'François Dubois',
      company: 'Epicerie Fine Paris',
      location: 'France',
      flag: '🇫🇷',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=professional%20French%20businessman%20formal%20attire%20confident%20smile%20portrait%20white%20background%20corporate%20headshot%20distinguished%20middle%20aged&width=200&height=200&seq=t8&orientation=squarish',
    },
    {
      text: 'The dried mushrooms from JB GlobeX are perfect for our food production line. Long shelf life, great aroma, and excellent nutritional value. We look forward to expanding our orders with them.',
      name: 'Li Wei',
      company: 'Asia Pacific Imports',
      location: 'Singapore',
      flag: '🇸🇬',
      rating: 5,
      image: 'https://readdy.ai/api/search-image?query=professional%20Singaporean%20Chinese%20businessman%20smart%20casual%20confident%20smile%20portrait%20white%20background%20corporate%20headshot%20modern&width=200&height=200&seq=t9&orientation=squarish',
    },
  ];

  useEffect(() => {
    const updateVisible = () => {
      setVisibleCount(window.innerWidth >= 1024 ? 3 : window.innerWidth >= 640 ? 2 : 1);
    };
    updateVisible();
    window.addEventListener('resize', updateVisible);
    return () => window.removeEventListener('resize', updateVisible);
  }, []);

  const maxIndex = testimonials.length - visibleCount;

  useEffect(() => {
    autoRef.current = setInterval(() => {
      setCurrentIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
    }, 4000);
    return () => { if (autoRef.current) clearInterval(autoRef.current); };
  }, [maxIndex]);

  const goTo = (index: number) => {
    setCurrentIndex(Math.max(0, Math.min(index, maxIndex)));
    if (autoRef.current) clearInterval(autoRef.current);
    autoRef.current = setInterval(() => {
      setCurrentIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
    }, 4000);
  };

  const prevSlide = () => goTo(currentIndex - 1);
  const nextSlide = () => goTo(currentIndex + 1);

  return (
    <section id="testimonials" className="py-12 lg:py-16 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        {/* Title */}
        <div className="text-center mb-10">
          <p className="text-teal-600 text-xs font-semibold uppercase tracking-wider mb-4">TESTIMONIALS</p>
          <h2 className="text-4xl lg:text-6xl font-bold text-gray-900 mb-4">
            What Our Global Partners Say
          </h2>
          <p className="text-lg text-gray-600">Trusted by international buyers across the globe</p>
        </div>

        {/* Slider */}
        <div className="relative overflow-hidden">
          <div
            className="flex transition-transform duration-500 ease-in-out"
            style={{ transform: `translateX(-${(currentIndex * 100) / visibleCount}%)` }}
          >
            {testimonials.map((testimonial, index) => (
              <div
                key={index}
                className="flex-shrink-0 px-3"
                style={{ width: `${100 / visibleCount}%` }}
              >
                <div className="bg-[#F9F7F4] rounded-2xl p-6 lg:p-8 h-full flex flex-col">
                  {/* Stars */}
                  <div className="flex space-x-1 mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-500 text-base"></i>
                    ))}
                  </div>

                  {/* Quote Icon */}
                  <div className="text-teal-600 mb-4">
                    <i className="ri-double-quotes-l text-4xl"></i>
                  </div>

                  {/* Text */}
                  <p className="text-gray-700 leading-relaxed mb-6 text-sm lg:text-base flex-1">
                    {testimonial.text}
                  </p>

                  {/* Divider */}
                  <div className="border-t border-gray-200 my-4"></div>

                  {/* Client Info */}
                  <div className="flex items-center space-x-4">
                    <div className="w-12 h-12 rounded-full overflow-hidden shrink-0 bg-gray-200">
                      <img
                        src={testimonial.image}
                        alt={testimonial.name}
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                    <div>
                      <h4 className="text-base font-bold text-gray-900">{testimonial.name}</h4>
                      <p className="text-gray-500 text-xs">
                        {testimonial.company} &bull; {testimonial.flag} {testimonial.location}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Navigation */}
        <div className="flex items-center justify-center space-x-6 mt-10">
          <button
            onClick={prevSlide}
            disabled={currentIndex === 0}
            className="w-11 h-11 bg-white border border-gray-200 rounded-full flex items-center justify-center hover:border-teal-600 hover:text-teal-600 transition-colors cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed"
          >
            <i className="ri-arrow-left-line text-lg"></i>
          </button>

          {/* Dots */}
          <div className="flex space-x-2">
            {Array.from({ length: maxIndex + 1 }).map((_, index) => (
              <button
                key={index}
                onClick={() => goTo(index)}
                className={`rounded-full transition-all cursor-pointer ${
                  index === currentIndex ? 'w-8 h-2.5 bg-teal-600' : 'w-2.5 h-2.5 bg-gray-300 hover:bg-gray-400'
                }`}
              ></button>
            ))}
          </div>

          <button
            onClick={nextSlide}
            disabled={currentIndex >= maxIndex}
            className="w-11 h-11 bg-white border border-gray-200 rounded-full flex items-center justify-center hover:border-teal-600 hover:text-teal-600 transition-colors cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed"
          >
            <i className="ri-arrow-right-line text-lg"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
